import { Chip } from '@mui/material';
import dayjs from 'dayjs';
import { type GridColDef } from 'esseal-data-table';
import { titleize } from 'inflection';

import { type Task } from '@/graphql/generated/graphql';
import DateTimeFormatter from '@/shared-components/DateTimeFormatter';

const tasksTableColumns: GridColDef<Task>[] = [
  {
    field: 'title',
    headerName: 'Title',
    width: 300,
  },
  {
    field: 'entityName',
    headerName: 'Related Entity',
    width: 200,
  },
  {
    field: 'description',
    headerName: 'Description',
    width: 400,
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 200,
    renderCell: (data) => <Chip label={titleize(data.row.status)} />,
  },
  {
    field: 'priority',
    headerName: 'Priority',
    width: 150,
    renderCell: (data) => <Chip label={titleize(data.row.priority)} />,
  },
  {
    field: 'assignee',
    headerName: 'Assignee',
    width: 150,
    renderCell: (data) => {
      const assignee = data.row.assignee?.employee;

      if (!assignee) {
        return <span>-</span>;
      }

      return <Chip label={titleize(`${assignee.firstName} ${assignee.lastName}`)} />;
    },
  },
  {
    field: 'creator',
    headerName: 'Assigned By',
    width: 150,
    renderCell: (data) => {
      const creator = data.row.creator?.employee;

      if (!creator) {
        return <span>-</span>;
      }

      return <Chip label={titleize(`${creator.firstName} ${creator.lastName}`)} />;
    },
  },
  {
    field: 'dueDate',
    headerName: 'Due Date',
    width: 150,
    renderCell: ({ row }) => {
      const dueDate = dayjs(row.dueDate as unknown as string);

      if (!dueDate.isValid()) return <span>-</span>;

      const diffDays = dueDate.diff(dayjs(), 'day');

      return (
        <DateTimeFormatter
          rawDate={row.dueDate}
          title={() => (diffDays < 0 ? `Overdue by ${Math.abs(diffDays)} days` : `${diffDays} days left`)}
        />
      );
    },
  },
];

export default tasksTableColumns;
